import React from 'react';
import { pdf, Font, Document, Page, Text,View, StyleSheet } from '@react-pdf/renderer';
import cl from './Contract.module.css'
import PDFicon from "../../../../assets/Icon/PdfIcon";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf'; 
import { baseFileURL } from '../../../../Api';
import { useTranslation } from 'react-i18next';


const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "იანვარი",
        "თებერვალი",
        "მარტი",
        "აპრილი",
        "მაისი",
        "ივნისი",
        "ივლისი",
        "აგვისტო",
        "სექტემბერი",
        "ოქტომბერი",
        "ნოემბერი",
        "დეკემბერი"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};

let primaryColor = "#000"
let ltd = "___________________"
let sk = "___________________"
let email = "___________________"
let tel = "032 2 11 12 13" 
let BOGbankAccount = "___________________"
let TBCbankAccountGel = "___________________"
let TBCbankAccountUSD = "___________________"
let address = "___________________"
let director = "___________________"
let director_pn = "___________________"

if(baseFileURL === 'https://finance.automoby.ge') {
    primaryColor = "#235e82"
    ltd = "შ.პ.ს. „ავტომობი“"
    sk = "446977022" 
    email = "info@automoby.ge" 
    tel = "(+995) 591 24 60 60; 0322 11 55 22 " 
    address = "დ.აღმაშენებლის 154, თბილისი" 
    BOGbankAccount = "GE74BG0000000533900476"
    TBCbankAccountGel = "___________________"
    TBCbankAccountUSD = "___________________"
    director = "ნინო ჩანადირი"
    director_pn = "01024069247"

} else if(baseFileURL === 'https://crm.aig.com.ge') {

    primaryColor = "#da0429" 
    ltd = "შ.პ.ს. „ავტო იმპორტ ჯორჯია“"
    sk = "406203120"
    email = "info@aig.com.ge" 
    tel = "(+995) 591 24 60 60; 0322 11 12 13" 
    address = "გიორგი სააკაძის მე-2 შესახვევი ატრიუმის ბიზნესცენტრი, 1-ლი სართული თბილისი, 0160, საქართველო" 
    BOGbankAccount = "GE19BG0000000131217994"
    TBCbankAccountGel = "GE54TB7734536020100004"
    TBCbankAccountUSD = "GE17TB7734536120100007"
    director = "მარიამ აქულაშვილი"
    director_pn = "01011091639"
}

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});



const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '40px 50px',
        fontSize: '10px',
        lineHeight: 1.5, 
        textAlign: 'justify',
    }, 
    
    p: { 
        marginBottom: '10px',
        textAlign: 'justify',
    }, 
    p0: { 
        marginBottom: '0px',
        textAlign: 'justify',
    }, 
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 

});

 


const MyDocument = ({ car }) => (
    <Document>

        <Page size="A4" style={styles.page}>
 
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px',}}>
                <Text>დეპოზიტის ხელშეკრულება</Text> 
            </View>
  
 
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '7px'}}>
                <Text>თბილისი</Text> 
                <Text>{formatDate(car.purchased_at)}</Text> 
            </View>

            {baseFileURL === 'https://finance.automoby.ge' ? 
                        <Text style={styles.p}>
                        ერთი მხრივ - {ltd} (ს.კ. {sk}) (შემდგომში „კომპანია“), ხელშეკრულებაში წარმოდგენილი დირექტორის {director}ს სახით (პ/ნ:{director_pn}) და  
                        მეორეს მხრივ -  {car.client.firstname} {car.client.lastname} (პ# {car.client.personal}) 
                        (შემდგომში „კლიენტი“) ვდებთ წინამდებარე ნასყიდობის ხელშეკრულებას შემდეგზე:
                    </Text>
            :
                <Text style={styles.p}>
                ერთი მხრივ - {ltd} (ს.კ. {sk}) (შემდგომში „კომპანია“), ხელშეკრულებაში წარმოდგენილი ადმინისტრაციის დეპარტამენტის 
                ხელმძღვანელის {director}ს სახით (პ/ნ:{director_pn}) და  
                მეორეს მხრივ -  {car.client.firstname} {car.client.lastname} (პ# {car.client.personal}) 
                (შემდგომში „კლიენტი“) ვდებთ წინამდებარე ნასყიდობის ხელშეკრულებას შემდეგზე:
                </Text>
            }
    
    

            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '10px', marginBottom: '5px', }}>
                <Text style={styles.b}>1. </Text>  ხელშეკრულების საგანი
            </Text> 
 
            <Text style={styles.p0}>
                <Text style={styles.b}>1.1. </Text> 
                  
                  პირველადი მომწოდებელი შეიძლება იყოს ნებისმიერი ფიზიკური ან იურიდიული პირი საქართველოში ან საქართველოს საზღვრებს გარეთ (უცხოური კომპანია), მათ შორის, ავტოსატრანსპორტო საშუალების შეძენა შეიძლება განხორციელდეს სხვადასხვა ელექტრონული პლატფორმებიდან, მათ შორის, საჯარო და დახურული ელექტრონული აუქციონებიდან, იმის მიხედვით, თუ სად იქნება განთავსებული გასაყიდად კლიენტის მიერ შერჩეული ნასყიდობის საგანი.

            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>1.2. </Text> პირველადი მომწოდებელი შეიძლება იყოს ნებისმიერი ფიზიკური ან იურიდიული პირი საქართველოში ან საქართველოს საზღვრებს გარეთ, მათ შორის, ავტოსატრანსპორტო საშუალების შეძენა შეიძლება განხორციელდეს სხვადასხვა ელექტრონული პლატფორმებიდან, მათ შორის, საჯარო და დახურული ელექტრონული აუქციონებიდან, იმის მიხედვით, თუ სად იქნება განთავსებული გასაყიდად კლიენტის მიერ შერჩეული ნასყიდობის საგანი.
            </Text>
 

            <Text style={styles.p0}>
                <Text style={styles.b}>1.3. </Text> კლიენტს უფლება აქვს, კომპანიის მიერ მის მიერ შერჩეული ავტოსატრანსპორტო საშუალების  შეძენამდე, შეცვალოს ნასყიდობის საგანი. კლიენტის მიერ ნასყიდობის საგნის შეცვლა შეიძლება დადასტურდეს ელექტრონული კომუნიკაციის საშუალებებით განხორციელებული მიმოწერით.
            </Text>
            

            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>2. </Text>  დეპოზიტი
            </Text> 


            <Text style={styles.p0}>
                <Text style={styles.b}>2.1. </Text> კლიენტი ვალდებულია წინამდებარე ხელშეკრულების ხელმოწერიდან 1 (ერთი) კალენდარული დღის ვადაში კომპანიას, ქვემოთ მითითებულ საბანკო რეკვიზიტებზე, გადაუხადოს წინასწარი ფულადი შენატანი - <Text style={styles.b}>{  
                        car.client_deposit 
                        } აშშ დოლარით</Text> აშშ დოლარის ოდენობით (შემდგომში ასევე „დეპოზიტი“).
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>2.2. </Text>  საბანკო ანგარიშები, რომელზეც კლეინტის მიერ ხდება ფინანსური ვალდებულებების შესრულება:
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.2.1. </Text>  საქართველოს ბანკის ანგარიში: <Text style={styles.b}>{BOGbankAccount}</Text>  GEL /USD
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.2.2. </Text>  თიბისი ბანკის ანგარიში: <Text style={styles.b}>{TBCbankAccountGel}</Text> GEL
            </Text>
            
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.2.3. </Text>  თიბისი ბანკის ანგარიში: <Text style={styles.b}>{TBCbankAccountUSD}</Text> USD
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>2.3. </Text>  
                კლეინტის მიერ დეპოზიტის გადახდით დასტრდება მისი ნამდვილი და გამოუხმობი ნება, მის მიერ შერჩეულ და კომპანიის მიერ შეძენილ (შეძენის შემთხვევაში) ავტოსატრანსპორტო საშუალებაზე კომპანიასთან დადოს ნასყიდობის ხელშეკრულება;
            </Text>
            
            

            <Text style={styles.p0}>
                <Text style={styles.b}>2.4. </Text>  დეპოზიტი ჩაითვლება ნასყიდობის საგნის ღირებულების ანგარიშში და შესაბამისად, გამოაკლდება ნასყიდობის საგნის ღირებულებას იმ შემთხვევაში, თუ კომპანია შეძლებს კლიენტის მიერ შერჩეული ავტოსატრანსპორტო საშუალების შეძენას პირველადი მომწოდებლისგან და მხარეთა შორის დაიდება ნასყიდობის ხელშეკრულება.
            </Text>
            
              
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.5. </Text> დეპოზიტს კომპანია დაუბრუნებს კლიენტს უკან, თუ კლიენტის მიერ შერჩეული ნასყიდობის საგნის შეძენა ვერ მოხერხდა პირველადი მომწოდებლისგან. შესაბამისად, კლიენტისთვის ცნობილია, რომ მის მიერ დეპოზიტის გადახდა არ წარმოადგენს იმის გარანტიას, რომ კომპანიის მიერ ნებისმიერ და ყველა შემთხვევაში განხორციელდება კლიენტის მიერ შერჩეული ავტოსატრანსპორტო საშუალების შეძენა მასზე რეალიზაციის მიზნით.
            </Text>
            
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.6. </Text>  2.4. პუნქტით განსაზღვრულ შემთხვევაში დეპოზიტი კლიენტს დაუბრუნდება 1 (ერთი) სამუშაო დღის განმავლობაში იმ მომენტიდან, როდესაც ცალსახად დადასტურდება, რომ კომპანიამ ვერ შეძლო კლიენტის მიერ შერჩეული ავტოსატრანსპორტო საშუალების შეძენა მასზე რეალიზაციის მიზნით. ასევე კლიენტს უფლება აქვს მოითხოვოს გადახდილი დეპოზიტის უკან დაბრუნება, მანამ სანამ კომპანიის მიერ მოხდება ავტოსატრასნპორტო საშუალების შეძენა და/ან მისი დაჯავშნა. ამ შემთხვევაში კომპანია დეპოზიტს დააბრუნებს კლიენტის მოთხოვნიდან 1 (ერთი) სამუშაო დღის ვადაში.

            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.7. </Text>  იმ შემთხვევაში, თუ კლიენტი, წინამდებარე ხელშეკრულების ხელმოწერიდან ერთი  კალენდარული დღის  მანძილზე არ გადაიხდის დეპოზიტს, კომპანია უფლებამოსილია ცალმხრივად შეწყვიტოს წინამდებარე ხელშეკრულება და არ  განახორციელოს კლიენტის მიერ წინასწარ შერჩეული ნასყიდობის საგნის შეძენა  მასზე შემდგომი გასხვისების მიზნით; 

            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.8. </Text>  იმ შემთხვევაში, თუ დეპოზიტის გადახდის შემდეგ კლიენტი უარს განაცხადებს მის მიერ შერჩეული ავტოსატრანსპორტო საშუალების შეძენაზე, თუმცა კომპანიის მიერ ნასყიდობის საგანი უკვე შეძენილი იქნება პირველადი მომწოდებლისგან ან შეძენის მიზნით კომპანიას უკვე დაჯავშნული ექნება ნასყიდობის საგანი, კომპანია უფლებამოსილია არ დააბრუნოს და პირგასამტეხლოს სახით დაიტოვოს დეპოზიტი ან მოსთხოვოს კლიენტს ჯავშნისთვის გადახდილი თანხის ანაზღაურება. იგივე წესი მოქმედებს, როდესაც კლიენტი უარს განაცხადებს ნასყიდობის ხელშეკრულების დადებაზე.
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.9. </Text> 
                 დეპოზიტი კლიენტს არ დაუბრუნდება იმ შემთხვევაშიც, თუ კლიენტი ისარგებლებს კომპანიის პარტნიორი კომერციული ბანკის საკრედიტო პროდუქტით (სესხით), ხოლო შემდეგ უარს განაცხადებს კომპანიასთან ამ ხელშეკრულებით განსაზღვრული ავტოსატრანსპორტო საშუალების ნასყიდობის ხელშეკრულების დადებაზე. კერძოდ, ავტოსატრანსპორტო საშუალების შეძენის მიზნით მიმართავს კომპანიის პარტნიორ კომერციულ ბანკს კრედიტის (როგორც წესი შეღავათიანი პირობების მქონე) აღების მიზნით, ხოლო კრედიტის დამტკიცებისა და მიღების შემდეგ, მას არამიზნობრივად განკარგავს, მათ შორის, არ დადებს ნასყიდობის ხელშეკრულებას და/ან არ შეიძენს კომპანიისგან შერჩეულ ავტომობილს და/ან უარს განაცხადებს ავტომობილის შერჩევაზე კომპანიისგან შეძენის მიზნით.
            </Text>
            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>3. </Text> ნასყიდობის ხელშეკრულების დადება
            </Text> 
            
      
            <Text style={styles.p0}>
                <Text style={styles.b}>3.1. </Text> ავტოსატრანსპორტო საშუალების შეძენის შესახებ და/ან ავტოსატრანსპორტო საშუალების დაჯავშნის შესახებ შეტყობინების მიღებიდან 1 (ერთი) სამუშაო დღის ვადაში კლიენტი ვალდებულია გააფორმოს ნასყიდობის ხელშეკრულება. 
            </Text>
      
            <Text style={styles.p0}>
                <Text style={styles.b}>3.2. </Text> კლიენტი წინამდებარე ხელშეკრულებაზე ხელმოწერით ადასტურებს, რომ კომპანიამ მას გაეცნო ნასყიდობის ხელშეკრულების პირობებს და ეთანხმება მათ. 

            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>3.3. </Text> კლიენტი ასევე აცხადებს, რომ მისთვის ცნობილია ნასყიდობის საგნის სავარაუდო ღირებულება, რომელიც დაზუსტდება კომპანიის მიერ ავტოსატრანსპორტო საშუალების პირველადი მომწოდებლისგან შეძენის შემდეგ, და ადასტურებს, რომ ნასყიდობის საგნის ღირებულებასთან დაკავშირებით არ ექნება პრეტენზიები ნასყიდობის ხელშეკრულების გაფორმების დროს.

            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>3.4. </Text> კლიენტის მოთხოვნის შემთხვევაში შესაძლებელია კომპანიასთან შეთანხმებით მოხდეს  ნასყიდობის ხელშეკრულებაში ცვლილებებისა და/ან დამატებების შეტანა. ამგვარი მოთხოვნის არ არსებობის შემთხვევაში, ჩაითვლება, რომ კლიენტი სრულად ეთანხმება ნასყიდობის ხელშეკრულების იმ ვერსიას (პირობებს), რომელსაც ის გაეცნო და რომლის გაცნობასაც ადასტურებს წინამდებარე ხელშეკრულებაზე ხელმოწერით.

            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>3.5. </Text> მხარეები თანხმდებიან, რომ წინამდებარე ხელშეკრულების გაფორმებამდე მათ შორის არსებული ყველა მიმოწერა, ზეპირი ან/და წერილობითი კომუნიკაცია/შეთანხმება წარმოადგენს ამ ხელშეკრულების და ნასყიდობის ხელშეკრულების განუყოფელ ნაწილს, თუმცა მხარეები ადასტურბენ, რომ თუ ისინი წინააღმდეგობაში მოდის (მოდიან)  წინამდებარე ხელშეკრულების ან/და ნასყიდობის ხელშეკრულების დებულებებთან, გამოიყენება ამ ხელშეკრულების ან ნასყიდობის ხელშეკრულების დებულებები. წინამდებარე ხელშეკრულებასა და ნასყიდობის ხელშეკრულებას შორის წინააღმდეგობის შემთხვევაში, გამოიყენება ნასყიდობის ხელშეკრულების დებულებები.
            </Text>
            


            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>4. </Text> დავების გადაწყვეტა
            </Text> 
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.1. </Text> ნებისმიერი დავა, წარმოშობილი წინამდებარე ხელშეკრულებასა და/ან მისი დანართ(ებ)თან დაკავშირებით, მათ შორის ნებისმიერი საკითხი ხელშეკრულების ან/და საარბიტრაჟო შეთანხმების არსებობის, ნამდვილობასა და შეწყვეტის შესახებ განხილვისა და საბოლოო გადაწყვეტილების მიღების მიზნით უნდა გადაეცეს მუდმივმოქმედ არბიტრაჟს „დავების განმხილველ ცენტრს“ DRC-ს. საარბიტრაჟო განხილვის ადგილია საქართველო თბილისი, რომლის სარეგისტრაციო კოდია 204547348, მის: ქ თბილისი ვაჟა-ფშაველას 71, სართ2,  ოფისი 11. ვებ.გვერდი: WWW.DRC.GE.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>4.2. </Text> მხარეები ვთანხმდებით, რომ მხარეებს შორის, ასევე საარბიტრაჟო დაწესებულება „დავების განმხილველი ცენტრს“ ს/კ 204547348 შორის კომუნიკაცია შესაძლებელია განხორციელდეს ელექტრონული ფორმით. ამ შემთხვევაში შეტყობინება განხორციელებულად ჩაითვლება, თუ იგი მხარეს ჩაბარდა ელექტრონული ფოსტის მეშვეობით. მხარეები თანხმობას აცხადებენ, რომ ხელშეკრულებით განსაზღვრულ ელ-ფოსტის მისამართზე ელექტრონული ფოსტის საშუალებით გაგზავნილი შეტყობინება მათთვის ჩაბარებულად ითვლება და აღნიშნულთან დაკავშირებით რაიმე სახის პრეტენზია არ ექნებათ.
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.3. </Text> თუ დავის საგნის ღირებულება არ აღემატება 100 000 (ასი ათასი) ლარს  დავა მუდმივმოქმედ არბიტრაჟ „დავების განმხილველ ცენტრში“ (DRC)  განხილული იქნება ზეპირი მოსმენის გარეშე.

            </Text>
            
  
             
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>5. </Text> კლიენტის პერსონალური მონაცემების დამუშავება
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>5.1. </Text> კლიენტი წინამდებარე ხელშეკრულებაზე ხელმოწერით თანხმობას აცხადებს კომპანიამ მისი პერსონალური მონაცემები დაამუშავოს პირდაპირი მარკეტინგის მიზნებისთვის, კერძოდ, კლიენტი თანხმობას აცხადებს {ltd}-სგან, მათ შორის, მის დამუშავებაზე უფლებამოსილი პირებისაგან {ltd}-ს სახელით ან {ltd}-ს დაკვეთით მოქმედი პირებისაგან, პერიოდულად მიიღოს მოკლე ტექსტური შეტყობინებები (SMS), ტექსტური, ხმოვანი, ელექტრონული და სხვა სახის შეტყობინებები, მათ შორის, ხმოვანი სატელეფონო ზარები, ტელეფონის, ფოსტის, ელექტრონული ფოსტის, სოციალური ქსელების ან სხვა ელექტრონული საშუალებით, {ltd}-ს ან/და {ltd}-ს  საქონლის/პროდუქტის, იდეის, მომსახურების, ფასდაკლების, აქციის, წამოწყების, წამახალისებელი ან სხვა გათამაშებების, პროექტების ან/და {ltd}-ს პარტნიორი ორგანიზაციების ერთობლივი პროექტების თაობაზე, ასევე მიიღოს  დაბადების დღის, დღესასწაულებისა და სხვა მნიშვნელოვანი და ღირსშესანიშნავი თარიღების თაობაზე მილოცვები, ინფორმაცია {ltd}-ში არსებული სამუშაოებისა და ვაკანსიების თაობაზე, ასევე, სხვა ნებისმიერი სახის სარეკლამო/მარკეტინგული შეთავაზებები.
            </Text>

               
  
             
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>6. </Text> დასკვნითი დებულებები
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>6.1. </Text> წინამდებარე ხელშეკრულებაში ცვლილებებისა და/ან დამატებების შეტანა ხორციელდება მხარეთა ურთიერთშეთანხმებით და წერილობითი ფორმით.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>6.2. </Text> საკითხები, რომელიც არ არის დარეგულირებული წინამდებარე ხელშეკრულებით გადაწყდება საქართველოს მოქმედი კანონმდებლობით.
            </Text>
             
            <Text style={styles.p0}>
                <Text style={styles.b}>6.3. </Text> ხელშეკრულების რომელიმე დებულების ბათილად ცნობა არ გამოიწვევს ხელშეკრულების დანარჩენი დებულებების ბათილობას.
            </Text>
             
            <Text style={styles.p0}>
                <Text style={styles.b}>6.4. </Text> 
                წინამდებარე ხელშეკრულება, ასევე ამ ხელშეკრულებასთან დაკავშირებული ნებისმიერი შეთანხმება, დოკუმენტი, განცხადება, რომელიც გაფორმდება ან/და გაიცვლება მხარეთა შორის, გარდა ჩვეულებრივი (სველი წესით) ხელმოწერისა, ასევე შეიძლება გაფორმდეს დისტანციურ რეჟიმში მხარეთა მიერ მათ მიერ ხელმოწერილი ეგზემპლიარის მეორე მხარისთვის  ელექტრონული ფოსტით ან/და SMS-ით გაგზავნის და მეორე მხარის მიერ მისი მიღების დადასტურების გზით ან/და ნებისმიერი სხვა დისტანციური/ელექტრონული საშუალებით (მათ შორის, Signify-თ), რომელიც იძლევა მხარეთა მიერ ნების გამოვლენის, ნების მიღებისა და/ან ხელშეკრულებაზე ხელისმოწერის გადმოწმების/დადასტურების საშუალებას.
            </Text>
            
             
            <Text style={styles.p0}>
                <Text style={styles.b}>6.5. </Text> ხელშეკრულება შედგენილია ქართულ ენაზე ორი თანაბარი იურიდიული ძალის მქონე ეგზემპლარად და მხარეთა მიერ ხელმოწერის შემდეგ თითოეული ეგზემპლარი გადაეცემათ მხარეებს. 
            </Text>
             
            <Text style={styles.p0}>
                <Text style={styles.b}>6.6. </Text> წინამდებარე ხელშეკრულება მხარის მოთხოვნით შეიძლება დაიდოს უცხო ენაზე, თუმცა ხელშეკრულების ქართულ ვერსიასა და უცხოურ ვერსიას შორის წინააღმდეგობის შემთხვევაში, უპირატესობა მიენიჭება ქართულ ვერსიას.
            </Text>
             
            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
               მხარეთა ხელმოწერები
            </Text> 
 
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#fff', padding: '20px 0px 0px'  }}>
 
                <View style={{ width: '50%', padding: '5px 20px 5px 0px', borderRight: '1px solid '+ primaryColor}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>კომპანია </Text>
                    <Text>{ltd}</Text>
                    <Text>ს/ნ:{sk}</Text>
                    <Text>მის: {address}</Text>
                    <Text>ტელ: {tel}</Text>
                    <Text>ელ-ფოსტა: {email}</Text>
                    {baseFileURL === 'https://finance.automoby.ge' ?
                    <Text style={{ textAlign: 'left' }}>დირექტორი: <Text style={{ fontFamily: 'HelveticaBold' }}> {director} (პ/ნ:{director_pn})</Text></Text>
                    :
                    <Text style={{ textAlign: 'left' }}>ადმინისტრაციული დეპარტამენტის ხელმძღვანელი: <Text style={{ fontFamily: 'HelveticaBold' }}> {director} (პ/ნ:{director_pn})</Text></Text>
                    }
                    <Text> </Text>
                    <Text>_______________________________________</Text>

                </View>
  
                <View style={{ width: '50%', paddingLeft: '20px', borderLeft: '1px solid '+ primaryColor}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>კლიენტი </Text>
                    <Text>{car.client.firstname} {car.client.lastname}  </Text>
                    <Text>პ/ნ: {car.client.personal} </Text>
                    <Text>ტელ: {car.client.mobile} </Text>
                    <Text>ელ-ფოსტა: {car.client.email} </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text style={{ marginBottom: '5px' }}> </Text>
                    <Text>_______________________________________</Text>
                 </View>
  
            </View>



        </Page>
 
    </Document>
);

const Deposit = ({ carItem }) => {
        const {t} = useTranslation();
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument car={carItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'Deposit.pdf';
        link.click();
    };

    return (
        <span className={cl.btn} onClick={generatePDF}><PDFicon /> {t('Contract')} </span>
    );
};

export default Deposit;
